<script>
import * as sdk from '../../functions/sdk';
import UiContainer from '../ui/Container';
import UiSubheader from '../ui/Subheader';
import UiButton from '../ui/Button';
import UiTabs from '../ui/Tabs';
import UiHeadline from '../ui/Headline';
import UiLoading from '../ui/Loading';
import UiModal from '../ui/Modal';
import UiPhonePreview from '../ui/PhonePreview';
import { store } from '../../functions/mixins';
import fileDownload from 'js-file-download';
import * as crossPopup from '../../functions/crossPopup';

const PAGESIZE = 50;

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiSubheader,
        UiButton,
        UiTabs,
        UiHeadline,
        UiLoading,
        UiModal,
        UiPhonePreview,
    },
    data() {
        return {
            items: [],
            loading: false,
            currentTab: 1,
            promiseId: 0,
            currentItem: null,
            modalDelete: {
                visible: false,
                loading: false,
                instance: null,
            },
            pagerSentOffset: 0,
            pagerSentLoading: false,
            pagerSentVisible: false,
            senderGroupId: null,
        };
    },
    computed: {
        sumStatFirst() {
            return this.userInfo && this.userInfo.sumStatFirst;
        },
        sortedCampaigns() {
            const {
                items,
                currentTab,
            } = this;
            if (currentTab !== 1) {
                return [];
            }
            return items.sort((a, b) => new Date(b.sendTime) - new Date(a.sendTime));
        },
    },
    created() {
        crossPopup.closeAllInstances();
        if (this.userInfo.hideStat) {
            this.$router.push({name: 'send'});
        }
        this.fetchContent();
    },
    methods: {
        fetchContent() {
            const promiseId = ++this.promiseId;
            let promise = [];
            this.loading = true;
            this.items = [];
            this.pagerSentVisible = false;
            this.pagerSentLoading = false;
            this.pagerSentOffset = 0;
            switch (this.currentTab) {
                case 1:
                    promise.push(sdk.pressengerControl.getSenderGroupId());
                    promise.push(sdk.pressengerControl.listPressages(false, 999));
                    promise.push(sdk.pressengerControl.listPressages(true, PAGESIZE).then(items => {
                        this.pagerSentOffset += items.length;
                        if (items.length === PAGESIZE) {
                            this.pagerSentVisible = true;
                        }
                        return items;
                    }));
                    break;
                case 2:
                    promise.push(sdk.pressengerControl.listNotifyLogoStat());
                    break;
                case 3:
                    promise.push(sdk.pressengerControl.listTransitionStat());
                    break;
            }
            Promise.all(promise).then(values => {
                if (promiseId === this.promiseId) {
                    values.forEach(items => {
                        if (typeof items === 'string') {
                            this.senderGroupId = items;
                        } else {
                            this.items = this.items.concat(items);
                        }
                    });
                    this.loading = false;
                }
            }).catch(() => {
                if (promiseId === this.promiseId) {
                    this.fetchContent();
                }
            });
        },
        loadMoreSent() {
            this.pagerSentLoading = true;
            sdk.pressengerControl.listPressages(true, PAGESIZE, this.pagerSentOffset).then(items => {
                this.items = this.items.concat(items);
                this.pagerSentOffset += items.length;
                if (items.length < PAGESIZE || items.length === 0) {
                    this.pagerSentVisible = false;
                }
            }).finally(() => {
                this.pagerSentLoading = false;
            })
        },
        getBubbleImage(fileName) {
            return sdk.getBubbleImage(this.userInfo.groupId, fileName);
        },
        getTransitionImage(fileName) {
            return sdk.getTransitionImage(this.userInfo.groupId, fileName);
        },
        toggleItem(item) {
            if (item === this.currentItem) {
                this.currentItem = null;
            } else {
                this.currentItem = item;
            }
        },
        calculatePercent(sent, open) {
            return !sent ? 0 : Math.round(open / sent * 100);
        },
        getPressageId(pressage) {
            return pressage.pressageId;
        },
        downloadCSV(pressage) {
            sdk.pressengerControl.getMassPressageLogCSV(pressage.pressageId).then(data => {
                fileDownload(data, 'export.csv');
            });
        },
        editFeedText(pressage) {
            const text = window.prompt(this.$t('perfomanceView.editFeedText'), pressage?.feed_text || '');
            if (text) {
                // TODO:
            }
        },
        deletePressage(pressage) {
            sdk.pressengerControl.removeMassPressage(this.getPressageId(pressage)).then(() => {
                if (this.currentTab === 1) {
                    this.items = this.items.filter(i => i !== pressage);
                }
            });
        },
        showModalDelete(instance) {
            this.modalDelete.visible = true;
            this.modalDelete.instance = instance;
        },
        hideModalDelete() {
            this.modalDelete.visible = false;
            this.modalDelete.instance = true;
        },
        executeModalDelete() {
            this.modalDelete.loading = true;
            sdk.pressengerControl.removeMassPressage(this.getPressageId(this.modalDelete.instance)).then(() => {
                if (this.currentTab === 1) {
                    this.items = this.items.filter(i => i !== this.modalDelete.instance);
                }
                this.hideModalDelete();
            }).finally(() => {
                this.modalDelete.loading = false;
            });
        },
        getPressageThumbUrl(pressage) {
            return sdk.getPressageThumbUrl(pressage);
        },
        copyTextToClip(text, event) {
            if (event) {
                event.stopPropagation();
            }
            const input = document.createElement('input');
            input.value = text;
            input.style.cssText = 'opacity: 0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        getNotificationImageSrc(item) {
            try {
                const json = JSON.parse(item.json);
                if (json.thumbUrl) {
                    return json.thumbUrl;
                }
                if (json.notificationImageName) {
                    return sdk.getNotificationImageURL(this.senderGroupId, json.notificationImageName);
                }
            } catch(e) { }
            return false;
        },
        calculateName: (name) => {
            if (name && name.startsWith('$$')) {
                return Buffer.from(name.substring(2), 'base64');
            } else {
                return name || '';
            }
        }
    },
    watch: {
        currentTab(nextVal) {
            this.fetchContent();
        },
    }
}
</script>

<template>
    <ui-container>
        <ui-modal :visible="modalDelete.visible">
            <ui-headline class="small mt-0">{{ $t('perfomanceView.deleteCampaignTitle') }}</ui-headline>
            <div v-html="$t('perfomanceView.deleteCampaignBody')"></div>
            <div class="FlexRow JustifyEnd">
                <ui-button @click.native="hideModalDelete()" :disabled="modalDelete.loading" class="white secondary">
                    {{ $t('perfomanceView.cancel') }}
                </ui-button>
                <ui-button @click.native="executeModalDelete()" :disabled="modalDelete.loading" class="white secondary ml-1">
                    {{ $t('perfomanceView.delete') }}
                </ui-button>
            </div>
        </ui-modal>
        <ui-headline>{{ $t('perfomanceView.pageTitle') }}</ui-headline>
        <ui-subheader>{{ $t('perfomanceView.pageSubtitle') }}</ui-subheader>
        <ui-tabs
            v-model="currentTab"
            :tabs="[
                {title: $t('perfomanceView.tabCampaigns'), value: 1},
                //{title: $t('perfomanceView.tabBubbles'), value: 2},
                //{title: $t('perfomanceView.tabTransitions'), value: 3},
            ]"
        >
            <router-link :to="{name: 'send'}" v-if="currentTab === 1" class="NewPressageButton">
                {{ $t('perfomanceView.tabCreate') }}
            </router-link>
        </ui-tabs>
        <div class="TabContent">
            <template v-if="currentTab === 1">
                <ui-loading v-if="loading" />
                 <div class="List">
                    <div class="ListItem" v-for="(i, key) in sortedCampaigns" :key="key" @click="toggleItem(i)">
                        <div class="ThumbnailNew" @click="e => copyTextToClip(i.pressageId, e)">
                            <!--
                            <ui-phone-preview
                                :view="'V_MESSAGE'"
                                :message="{
                                    type: 'MT_IMAGES',
                                    payload: [getPressageThumbUrl(i)],
                                }"
                                :maxWidth="135"
                                :maxHeight="135"
                            />
                            -->
                            <img :src="getNotificationImageSrc(i)" />
                            <div class="Tooltip">{{ i.pressageId }}</div>
                        </div>
                        <div class="Content">
                            <div class="Title">{{ calculateName(i.name) }}</div>
                            <div class="Info">
                                <span class="Channel">{{ i.sender }}</span>
                                <span class="Divider"></span>
                                <template v-if="i._sent">
                                    <span class="Time">{{ i.sendTime }}</span>
                                </template>
                                <div class="FlexRow  AlignCenter" v-else>
                                    <div class="FlexColumn">
                                        <span class="Time">{{ i.created }}</span>
                                        <span class="Time">{{ i.sendTime }}</span>
                                    </div>
                                    <span class="mdi mdi-camera-timer fg-red ml-1 mdi-24px" />
                                </div>
                            </div>
                        </div>
                        <div class="Stats">
                            <div :class="{StatsGroup: true, expand: currentItem === i, Pointer: true}">
                                <span class="Title">&nbsp;</span>
                                <span class="Data">
                                    <span class="mdi mdi-android"></span>
                                    <span class="mdi mdi-apple"></span>
                                    <span :class="['mdi', 'mdi-sigma', {PushTop: sumStatFirst}]"></span>
                                </span>
                            </div>
                            <span class="Divider"></span>
                            <div :class="{StatsGroup: true, FixedWidth: true, expand: currentItem === i}">
                                <span class="Title">{{ $t('perfomanceView.appeared') }}</span>
                                <span class="Data">
                                    <span>{{ i.sentCountA }}</span>
                                    <span>{{ i.sentCountI }}</span>
                                    <span :class="{PushTop: sumStatFirst}">{{ i.sentCountA + i.sentCountI }}</span>
                                </span>
                            </div>
                            <span class="Divider"></span>
                            <div :class="{StatsGroup: true, FixedWidth: true, expand: currentItem === i}">
                                <span class="Title">{{ $t('perfomanceView.opened') }}</span>
                                <span class="Data">
                                    <span>
                                        {{ calculatePercent(i.sentCountA, i.notiClickCountA) }}%
                                        <small>({{ i.notiClickCountA }})</small>
                                    </span>
                                    <span>
                                        {{ calculatePercent(i.sentCountI, i.notiClickCountI) }}%
                                        <small>({{ i.notiClickCountI }})</small>
                                    </span>
                                    <span :class="{PushTop: sumStatFirst}">
                                        {{ calculatePercent(i.sentCountA + i.sentCountI, i.notiClickCountA + i.notiClickCountI) }}%
                                        <small>({{ i.notiClickCountA + i.notiClickCountI }})</small>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="Actions">
                            <ui-button @click.native.stop="downloadCSV(i)" class="icon secondary white big" v-if="userInfo.enableStatDownload === true">
                                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13.03" height="16" viewBox="0 0 13.03 16" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.742 5.673l-5.586 6.039a.875.875 0 01-.644.288.873.873 0 01-.643-.288L.283 5.673a1.04 1.04 0 010-1.391.863.863 0 011.287 0L5.2 8.207V0h2.6v8.234l3.655-3.952a.863.863 0 011.287 0 1.042 1.042 0 010 1.391zM13 16H0v-2.667h13V16z"/></svg>
                            </ui-button>
                            <ui-button @click.native.stop="editFeedText()" class="icon secondary white big" v-if="i.feed_active">
                                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="31" height="31" viewBox="0 0 31 31" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M28.542 8.259a3.258 3.258 0 00.958-2.32c0-.879-.34-1.703-.958-2.321l-1.16-1.16a3.259 3.259 0 00-2.321-.958c-.878 0-1.702.34-2.32.958L15.499 9.7 7.307 1.508 1.506 7.309l8.192 8.192-6.264 6.264L1.5 29.5l7.735-1.934 6.264-6.264 8.192 8.192 5.801-5.801-8.192-8.192 7.242-7.242zm-4.641-4.641c.308-.308.72-.477 1.16-.477.44 0 .852.169 1.161.477l1.16 1.16c.308.308.477.721.477 1.161 0 .44-.169.852-.477 1.16l-.58.58-3.481-3.481.58-.58zm-1.74 1.741l3.48 3.48-1.16 1.16-3.48-3.48 1.16-1.16zM3.826 7.309l3.481-3.48 1.57 1.57-1.16 1.16 1.16 1.16 1.161-1.16 1.57 1.571-1.16 1.16 1.16 1.16 1.16-1.16 1.571 1.57-3.481 3.481-7.032-7.032zm16.014.37l1.161 1.16L6.495 23.345l-1.16-1.16L19.84 7.679zM3.755 27.245l.864-3.456 2.591 2.592-3.455.864zm5.06-1.58l-1.16-1.16L22.161 9.999l1.16 1.161L8.815 25.665zm12.895-7.433l-1.16 1.16 1.16 1.16 1.16-1.16 1.571 1.57-1.16 1.161 1.16 1.16 1.16-1.16 1.57 1.57-3.48 3.481-7.032-7.032 3.481-3.481 1.57 1.571z"/></svg>
                            </ui-button>
                            <ui-button @click.native.stop="showModalDelete(i)" class="icon secondary white big">
                                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                            </ui-button>
                        </div>
                    </div>
                    <div class="Alert" v-if="!loading && !items.length">
                        {{ $t('perfomanceView.noResults') }}
                    </div>
                </div>
                <div v-if="pagerSentVisible" class="Pager">
                    <ui-loading v-if="pagerSentLoading" />
                    <ui-button v-else @click.native.stop="loadMoreSent()" class="secondary white small ma-2">
                        {{ $t('perfomanceView.loadMore') }}
                    </ui-button>
                </div>
            </template>
            <!--
            <template v-else-if="currentTab === 2">
                <ui-loading v-if="loading" />
                <div class="List">
                    <div class="ListItem" v-for="(i, key) in items" :key="key">
                        <div class="Thumbnail">
                            <img :src="getBubbleImage(i.imgUrl)" class="Preview" alt="" />
                        </div>
                        <div class="Content">
                            <div class="Title">{{ i.imgUrl }}</div>
                        </div>
                        <div class="Stats">
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.associations') }}</span>
                                <span class="Data">{{ i.associatedCount }}</span>
                            </div>
                            <span class="Divider"></span>
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.sent') }}</span>
                                <span class="Data">{{ i.sendCount }}</span>
                            </div>
                            <span class="Divider"></span>
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.seen') }}</span>
                                <span class="Data">{{ i.sentCount }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="Alert" v-if="!loading && !items.length">
                        {{ $t('perfomanceView.noResults') }}
                    </div>
                </div>
            </template>
            <template v-else-if="currentTab === 3">
                <ui-loading v-if="loading" />
                <div class="List">
                    <div class="ListItem" v-for="(i, key) in items" :key="key">
                        <div class="Thumbnail">
                            <img :src="getTransitionImage(i.imgUrl)" class="Preview" alt="" />
                        </div>
                        <div class="Content">
                            <div class="Title">{{ i.imgUrl }}</div>
                        </div>
                        <div class="Stats">
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.associations') }}</span>
                                <span class="Data">{{ i.associatedCount }}</span>
                            </div>
                            <span class="Divider"></span>
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.sent') }}</span>
                                <span class="Data">{{ i.sendCount }}</span>
                            </div>
                            <span class="Divider"></span>
                            <div class="StatsGroup">
                                <span class="Title">{{ $t('perfomanceView.seen') }}</span>
                                <span class="Data">{{ i.sentCount }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="Alert" v-if="!loading && !items.length">
                        {{ $t('perfomanceView.noResults') }}
                    </div>
                </div>
            </template>
            -->
        </div>
    </ui-container>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

transform2(value)
    transform: value

.fg-red
    color $cError;

.TabContent
    background #fff
    border 1px solid $cBorder
    border-top none
    font-weight 600
    font-size 24px

.List
    .ListItem
        display flex
        justify-content flex-start
        align-items center
        padding 15px 30px
        border-bottom 1px solid $cBorder
        color $cPrimary
        white-space nowrap
        flex 1 1 auto
        transition: .3s all;
        &:hover {
            background: #FBFFE2;
        }
        &:last-child
            border-bottom none
        .ThumbnailNew
            flex 0 0 auto
            margin-right 15px
            position relative
            cursor pointer
            width 240px
            min-height 30px
            box-shadow: 0 0 2px rgba(0,0,0,.2)
            img
                max-width 100%
                display block
            .Tooltip
                position absolute
                top 50%
                left 50%
                transform2(translate(-50%, -50%) scale(0))
                background rgba(0,0,0,.6)
                color #fff
                font-size 8px
                padding 4px
                border-radius 5px
                transition all .3s
            &:hover
                .Tooltip
                    transform2(translate(-50%, -50%) scale(1))
        .Thumbnail
            position relative
            height 135px
            width 135px
            margin-right 15px
            padding 15px 0
            overflow hidden
            flex 0 0 auto
            .Frame
                position absolute
                left 50%
                top 50%
                transform translate(-50%, -50%)
                max-height 135px
                max-width 135px
                z-index 2
            .Preview
                position absolute
                left 50%
                top 50%
                transform translate(-50%, -50%)
                max-height 135px
                max-width 135px
                z-index 1
        .Content
            display flex
            flex-direction column
            justify-content flex-start
            align-items flex-start
            flex 1 1 0px
            overflow hidden
            .Title
                align-self stretch
                font-size 20px
                line-height 30px
                font-weight 600
                white-space normal
                max-height 60px
                overflow hidden
            .Info
                display flex
                align-items center
                font-size 12px
                font-weight 400
                .Time
                    font-weight 500
                .Divider
                    display inline-block
                    background $cAccent
                    width 3px
                    height 3px
                    border-radius 50%
                    margin 0 10px
        .Stats
            display flex
            align-items center
            flex 0 0 auto
            margin-left 20px
            .Divider
                display inline-block
                position relative
                background $cBorder
                width 3px
                height 3px
                border-radius 50%
                margin 0 20px
                &:before
                    content ''
                    display inline-block
                    position absolute
                    background $cBorder
                    width 3px
                    height 3px
                    border-radius 50%
                    bottom: calc(100% + 5px)
                &:after
                    content ''
                    display inline-block
                    position absolute
                    background $cBorder
                    width 3px
                    height 3px
                    border-radius 50%
                    top: calc(100% + 5px)
            .StatsGroup
                display flex
                flex-direction column
                align-items center
                &.Pointer {
                    cursor: pointer;
                }
                .Title
                    font-size 12px
                    font-weight 400
                .Data
                    display flex
                    flex-direction column
                    align-items center
                    font-size 34px
                    line-height 40px
                    font-weight 600
                    overflow hidden
                    transition all .3s
                    max-height 40px
                    span
                        order 2
                        &.PushTop
                            order 1
                        small
                            font-size: 14px
                            display: inline-block;
                            margin: 0;
                            padding: 0;
                            line-height: normal;
                    &.DataSmall
                        font-size 20px
                &.FixedWidth
                    width 110px
                    overflow hidden
                &.expand
                    .Data
                        max-height 120px
        .Actions
            display flex
            align-items center
            margin-left 80px
            flex 0 0 auto
            path
                fill $cPrimary
            & > *
                margin-right 20px
                &:last-child
                    margin-right 0

.Pager
    display flex
    align-items center
    justify-content center
    border-top 1px solid $cBorder

.NewPressageButton
    position relative
    font-size 15px
    font-weight bold
    color $cPrimary
    height 100%
    display flex
    justify-content center
    align-items center
    outline 0
    text-decoration none
    &:after
        position absolute
        content ""
        height 3px
        bottom 15px
        left 0
        right 0
        background linear-gradient(to right, #2FFAE6, #544FFF)
</style>
